// THIS IS FRAGILE AND REQUIRES MAINTENANCE ALONGSIDE THE CLIENT APP
// WE CAN JUST GO BACK TO FREE FORM TEXT ENTRY, BUT THIS SEEMED MORE CONVENIENT

/**
 * Where a marketing content card can link inside the client app. The stack/screen pair feeds
 * `navigate(stack, { screen })`, called from inside HomeStack — so React Navigation only
 * resolves the client's Drawer screens and tab names, not arbitrary screen names.
 *
 * Curated by hand, not generated: most of clientmobile's ~200 screens need params (a promo, a
 * mem_id, an enrollment) and would land broken if linked cold, so only self-standing
 * destinations are listed. The same pair drives the Firebase dynamic links (App.js reads
 * `?routing=…&stack=…&route=…` and makes the identical call), so this covers both routes in.
 */
export const IN_APP_DESTINATIONS = [
	{
		stack: 'Services',
		label: 'Services',
		screens: [
			{ name: 'Memberships', label: 'Memberships' },
			{ name: 'MyMemberships', label: 'My Memberships' },
			{ name: 'GettingStarted', label: 'Getting Started' },
			{ name: 'Promotions', label: 'Promotions' },
			{ name: 'Pets', label: 'Pets' },
			{ name: 'Profile', label: 'Profile' },
			{ name: 'Gallery', label: 'Gallery' }
		]
	},
	{
		stack: 'DaycareStack',
		label: 'Daycare',
		screens: [
			{ name: 'ScheduleDaycare', label: 'Schedule Daycare' },
			{ name: 'WelcomeDay', label: 'Welcome Day' }
		]
	},
	{
		stack: 'Boarding',
		label: 'Boarding',
		screens: [{ name: 'ScheduleBoarding', label: 'Schedule Boarding' }]
	},
	{
		stack: 'GroomingStack',
		label: 'Grooming',
		screens: [
			{ name: 'BookGrooming', label: 'Book Grooming' },
			{ name: 'AboutGrooming', label: 'About Grooming' },
			{ name: 'BookBathingAndHygiene', label: 'Book Bathing & Hygiene' },
			{ name: 'AboutBathingAndHygiene', label: 'About Bathing & Hygiene' }
		]
	},
	{
		stack: 'HomeServiceStack',
		label: 'Home Services',
		screens: [
			{ name: 'Schedule', label: 'Schedule a Visit' },
			{ name: 'ScheduleConsultation', label: 'Schedule a Consultation' }
		]
	},
	{
		stack: 'CheckInStack',
		label: 'Check In',
		screens: [{ name: 'StartCheckIn', label: 'Start Check In' }]
	},
	{
		stack: 'BankInt',
		label: 'Bank',
		screens: [
			{ name: 'FacilityBank', label: 'Facility Bank' },
			{ name: 'DaycareCreditSelection', label: 'Buy Daycare Credits' },
			{ name: 'HomeServiceBank', label: 'Home Service Bank' }
		]
	},
	{
		stack: 'Calendar',
		label: 'Calendar',
		screens: [{ name: 'Calendar', label: 'Calendar' }]
	},
	{
		stack: 'More',
		label: 'More',
		screens: [
			{ name: 'HouseholdProfile', label: 'Household Profile' },
			{ name: 'UserSettings', label: 'User Settings' },
			{ name: 'Pets', label: 'Pets' }
		]
	}
]

export const screensForStack = (stack) => {
	if (!stack) {
		return []
	}

	const match = IN_APP_DESTINATIONS.find((destination) => destination.stack === stack)

	return match ? match.screens : []
}
